module.exports = __webpack_public_path__ + "h5/img/add_01.9f9f9d0a.png";